import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin, Image } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useShoppingCenter from '../useShoppingCenter';
import { useMemo } from 'react';
import { getShoppingCenterViewSections } from '../shoppingCenterViewSections';

const ViewSection = ({ title, fields, singleShop }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => {
      if (item.key === 'extrastock_map') {
        return (
          <List.Item>
            <b className={styles.itemName}>{item.text}</b>
            {singleShop?.extrastock_map ? (
              <Image src={singleShop.extrastock_map} />
            ) : (
              '—'
            )}
          </List.Item>
        );
      }
      return (
        <List.Item>
          <b className={styles.itemName}>{item.text}</b>
          {item.value}
        </List.Item>
      );
    }}
  />
);

const SingleShop = () => {
  const { t } = useTranslation();
  const { singleShop, loading } = useShoppingCenter(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const sections = useMemo(
    () => getShoppingCenterViewSections(t, singleShop),
    [t, singleShop],
  );

  const title = isSuccessUpdatePage
    ? t('SHOPPING CENTER WAS SUCCESSFULLY UPDATED')
    : t('SHOPPING CENTER');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
              singleShop={singleShop}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleShop?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/shopping_centers/${singleShop?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/shopping_centers'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleShop;
